module.exports = __webpack_public_path__ + "img/9788936456689.2a1efd21.jpg";